<ziro-fieldset-header [legend]="'tkey;snr.snrdestination.label'">
  <ziro-navset data-automation="snr-navset" fieldId="snrNavset"></ziro-navset>
</ziro-fieldset-header>
